import styled from "styled-components";

const NavButtonStyled = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    
    .profile{
        position: relative;
        
    }
    

`;


export default NavButtonStyled;